import { ActionContext, Module } from 'vuex';
import { Verrechnungsart } from '@/types/Verrechnungsart';
import { LastImpfung, RootState, SessionState } from '@/store/types';

type Context = ActionContext<SessionState, RootState>;

export const session: Module<SessionState, RootState> = {
    namespaced: true,
    state: {
        arzt: null,
        assistenz: null,
        arbeitsplatz: null,
        lastImpfung: null,
        lastNachtrag: null,
        impfstelle: null,
        abrechnung: null,
        abrechnungLeistung: null,
        verrechnungUntersuchung: null,
        warteliste: true,
    },
    actions: {
        setSelectedArzt({ commit }: Context, payload: number): void {
            commit('setSelectedArzt', payload);
        },
        setSelectedAssistenz({ commit }: Context, payload: number): void {
            commit('setSelectedAssistenz', payload);
        },
        setSelectedArbeitsplatz({ commit }: Context, payload: number): void {
            commit('setSelectedArbeitsplatz', payload);
        },
        setLastImpfung({ commit }: Context, payload: { impfung: LastImpfung | null, nachtrag: boolean }): void {
            commit('setLastImpfung', payload);
        },
        setSelectedImpfstelle({ commit }: Context, payload: number): void {
            commit('setSelectedImpfstelle', payload);
        },
        setSelectedAbrechnung({ commit }: Context, payload: Verrechnungsart): void {
            commit('setSelectedAbrechnung', payload);
        },
        setSelectedAbrechnungLeistung({ commit }: Context, payload: Verrechnungsart): void {
            commit('setSelectedAbrechnungLeistung', payload);
        },
        setSelectedVerrechnungUntersuchung({ commit }: Context, payload: string): void {
            commit('setSelectedVerrechnungUntersuchung', payload);
        },
        setShowWarteliste({ commit }: Context, payload: boolean): void {
            commit('setShowWarteliste', payload);
        },
    },
    mutations: {
        setSelectedArzt(state: SessionState, arzt: number): void {
            state.arzt = arzt;
        },
        setSelectedAssistenz(state: SessionState, assistent: number): void {
            state.assistenz = assistent;
        },
        setSelectedArbeitsplatz(state: SessionState, arbeitsplatz: number): void {
            state.arbeitsplatz = arbeitsplatz;
        },
        setLastImpfung(state: SessionState,
                       { impfung, nachtrag }: { impfung: LastImpfung | null, nachtrag: boolean }): void {
            if (nachtrag) {
                state.lastNachtrag = impfung;
            } else {
                state.lastImpfung = impfung;
            }
        },
        setSelectedImpfstelle(state: SessionState, impfstelle: number): void {
            state.impfstelle = impfstelle;
        },
        setSelectedAbrechnung(state: SessionState, abrechnung: Verrechnungsart): void {
            state.abrechnung = abrechnung;
        },
        setSelectedAbrechnungLeistung(state: SessionState, abrechnung: Verrechnungsart): void {
            state.abrechnungLeistung = abrechnung;
        },
        setSelectedVerrechnungUntersuchung(state: SessionState, verrechnung: string): void {
            state.verrechnungUntersuchung = verrechnung;
        },
        setShowWarteliste(state: SessionState, visible: boolean): void {
            state.warteliste = visible;
        },
    },
};
